import _ from 'lodash';
import { createContext, useContext, useEffect, useReducer, useState } from 'react';

const NavigationContext = createContext(null);

// export type NavItem = {
//   pageId: string;
//   params: Map<String, String>;
// }

export function NavigationProvider({ children }) {
  const [pages, setPages] = useState([]);

  const value = {
    to: (navItem) => {
      const currentPage = pages.length > 0 ? pages[pages.length - 1] : null;
      if (!_.isEqual(currentPage, navItem)) {
        setPages([...pages, navItem]);
      }
    },
    back: () => {
      if (pages.length > 1) {
        setPages(pages.slice(0, pages.length - 1));
      }
    },
    currentPage: pages.length > 0 ? pages[pages.length - 1] : null,
  };

  return <NavigationContext.Provider value={value}>{children}</NavigationContext.Provider>;
}

export function useNavigation() {
  return useContext(NavigationContext);
}
